import { render, staticRenderFns } from "./wares.vue?vue&type=template&id=6625d895&scoped=true&"
import script from "./wares.vue?vue&type=script&lang=js&"
export * from "./wares.vue?vue&type=script&lang=js&"
import style0 from "./wares.vue?vue&type=style&index=0&id=6625d895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625d895",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6625d895')) {
      api.createRecord('6625d895', component.options)
    } else {
      api.reload('6625d895', component.options)
    }
    module.hot.accept("./wares.vue?vue&type=template&id=6625d895&scoped=true&", function () {
      api.rerender('6625d895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/wares.vue"
export default component.exports